module.exports = __webpack_public_path__ + "../resources/img/checkbox_unselected.9bc46d74.svg";